import React from "react";
// React Table
import { Table } from "react-bootstrap";
// Utils
import { formatDate } from "../../../utils";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaCanonicos = ({ datosComunidad }) => {
  return (
    <Table bordered responsive>
      <tbody>
        <tr>
          <CustomTd className={"w-50"}>
            <span>Nombre</span>
          </CustomTd>
          <td>{datosComunidad?.name || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Erigida</span>
          </CustomTd>
          <td>{formatDate(datosComunidad?.startDate) || <small>No especificado</small>}</td>
        </tr>
        {datosComunidad?.endDate && <tr>
          <CustomTd>
            <span>Suprimida</span>
          </CustomTd>
          <td>{formatDate(datosComunidad?.endDate) || <small>No especificado</small>}</td>
        </tr>}
        <tr>
          <CustomTd>
            <span>Diócesis</span>
          </CustomTd>
          <td>{datosComunidad?.diocese || <small>No especificado</small>}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default VistaCanonicos;
